import { useApiClient } from "@/infrastructure/rest";
import { useMutation } from "@tanstack/react-query";

export function useUploadRoutes() {
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (file: File) => {
            await apiClient.uploadFile(`/debug/upload/tvv/routes`, file);
        },
        onError: (error) => {
            console.error("Error uploading TVV routes file:", error);
        },
    });
}

export function useUploadRijtijden() {
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (file: File) => {
            await apiClient.uploadFile(`/debug/upload/tvv/rijtijden`, file);
        },
        onError: (error) => {
            console.error("Error uploading TVV rijtijden file:", error);
        },
    });
}
